<template>
  <v-card>
    <!-- {{editItem}} -->
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>edit</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Edit Visa Details</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%">
      <v-form ref="editProjectMedicalForm" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex sm6 class="pr-1">
            <v-radio-group
              required
              v-model="editItem.project_owner"
              row
              label="Project Owner: *"
            >
              <v-radio
                :label="item.text"
                :value="item.value"
                v-for="(item, index) in projectOwnersTV"
                :key="index"
              ></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex md6 class="pr-1">
            <v-autocomplete
              label="Service Type *"
              v-model="editItem.service_type"
              :items="serviceTypes"
              hide-details
              hide-selected
              item-text="text"
              item-value="value"
              outline
              required
              :rules="requiredRules"
            >
            </v-autocomplete>
          </v-flex>
        </v-layout>

        <v-layout class="mb-4">
          <v-flex md6 class="pr-1">
            <v-autocomplete
              label="Company *"
              v-model="editItem.employer_id"
              :items="employersTV"
              hide-details
              hide-selected
              item-text="text"
              item-value="value"
              outline
              required
              :rules="requiredRules"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex md6 class="pr-0">
            <v-autocomplete
              label="Visa number *"
              v-model="editItem.visa_number_id"
              :items="visaNumbersTV"
              hide-details
              hide-selected
              item-text="text"
              item-value="value"
              outline
              required
              :rules="requiredRules"
            >
            </v-autocomplete>
          </v-flex>
        </v-layout>

        <v-layout row wrap class="pb-0">
          <v-flex md6 class="pr-1">
            <v-menu
              v-model="mofaDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="editItem.mofa_date"
                  label="MOFA date *"
                  readonly
                  outline
                  v-on="on"
                  required
                  :rules="requiredRules"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="editItem.mofa_date"
                @input="mofaDateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex md6 class="pr-1">
            <v-text-field
              outline
              label="MOFA Number *"
              v-model="editItem.mofa_number"
              required
              :rules="requiredRules"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex md6 class="pr-1">
            <v-autocomplete
              label="Trade name *"
              v-model="editItem.trade_name_id"
              :items="tradesTV"
              hide-details
              hide-selected
              item-text="text"
              item-value="value"
              outline
              required
              :rules="requiredRules"
            >
            </v-autocomplete>
          </v-flex>
          <v-flex md6 class="pr-1">
            <v-menu
              v-model="embassySubmitDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="editItem.embassy_submit_date"
                  label="Embassy Submit date"
                  readonly
                  outline
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="editItem.embassy_submit_date"
                @input="embassySubmitDateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>

        <v-text-field outline label="Remark" v-model="editItem.mofa_notes"></v-text-field>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="onCancelled">Cancel</v-btn>
      <v-btn
        color="blue"
        @click="editItemDo"
        :disabled="!valid || actionButtonClicked"
        :loading="actionButtonClicked"
        >Update</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  GENDERS,
  MEDICAL_STATUSES,
  FINGER_STATUSES,
  VISA_TYPES,
  SERVICE_TYPES,
  PROJECT_OWNER,
  COUNTRIES,
  NATIONALITIES,
  RELIGIONS,
  MARITAL_STATUSES,
  LANGUAGES,
} from "../../mdsir/const";
import {
  getTV,
  removeEmptyProps,
  districtTV,
  upazilaTV,
  unionTV,
} from "../../mdsir/MdsirUtils";

export default {
  props: ["editItem", "agents", "employers", "trades", "visaNumbers"],
  data() {
    return {
      actionButtonClicked: false,
      valid: true,

      contractDateMenu: false,
      dobDateMenu: false,
      medicalDateMenu: false,
      mofaDateMenu: false,
      trainingStartDateMenu: false,
      trainingEndDateMenu: false,
      visaIssueDateMenu: false,
      flightDateMenu: false,
      COUNTRIES: COUNTRIES,
      NATIONALITIES: NATIONALITIES,
      RELIGIONS: RELIGIONS,
      MARITAL_STATUSES: MARITAL_STATUSES,
      LANGUAGES: LANGUAGES,
      passportIssueDateMenu: false,
      passportExpDateMenu: false,
      embassySubmitDateMenu: false,
    };
  },
  computed: {
    medicalStatuses() {
      return getTV(MEDICAL_STATUSES);
    },
    fingerStatuses() {
      return getTV(FINGER_STATUSES);
    },
    visaTypes() {
      return getTV(VISA_TYPES);
    },
    serviceTypes() {
      return getTV(SERVICE_TYPES);
    },
    agentsTV() {
      return getTV(this.agents, { textField: "name", valueField: "id" });
    },
    employersTV() {
      return getTV(this.employers, { textField: "name", valueField: "id" });
    },
    projectOwnersTV() {
      return getTV(PROJECT_OWNER, { isDeselect: false });
    },
    tradesTV() {
      return getTV(this.trades, { textField: "name", valueField: "id" });
    },
    visaNumbersTV() {
      const visaNums = this.editItem && this.editItem.employer_id ? 
      this.visaNumbers.filter(r => r.employer_id == this.editItem.employer_id)
      : this.visaNumbers;
      return getTV(visaNums, { textField: "visa_no", valueField: "id" });
    },
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    },
    validate() {
      if (this.$refs.editProjectMedicalForm.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.editProjectMedicalForm.reset();
    },
    resetValidation() {
      this.$refs.editProjectMedicalForm.resetValidation();
    },
    editItemDo() {
      if (this.$refs.editProjectMedicalForm.validate()) {
        this.actionButtonClicked = true;
        this.put(
          "/visa_details",
          removeEmptyProps(this.editItem, [
            "contract_date",
            "dob",
            "visa_issue_date",
            "flight_date",
            "medical_date",
            "mofa_date",
            "training_start_date",
            "training_end_date",
            "embassy_submit_date",
          ])
        ).then((res) => {
          if (res.data.success) {
            this.onCancelled();
          }
          this.snackbarShow(res.data);
          this.actionButtonClicked = false;
        });
      }
    },
    districtTV: districtTV,
    upazilaTV: upazilaTV,
    unionTV: unionTV,
    getTV: getTV,
  },
  mounted() {},
  created() {
    this.GENDERS = GENDERS;
  },
};
</script>
